<template>
    <div class="ChatWindow">
        <div class="ChatHead">

        </div>

        <div class="ChatWindowMain">
            <div class="ChatWrap clear">
                <div  class="ChatWindowCon" id="MsgWindowCon">
                    <h2 class="KefuName" id="KefuName" v-if="kefuName == ''" >
                        -
                    </h2>
                    <h2 class="KefuName" id="KefuName" v-else v-html="kefuName.replace(/\n/g, '<br >')">
                        -
                    </h2>
                        <!--聊天面板-->
                        <ul class="ChatWindowDiv" id="ChatWindow">
                            <li v-for="item in ContactItem"
                                :class="[item.oper_code === 2002 ? 'MeCon' : 'FriendsCon']"
                                :ids="item.id">
                                <p class="ChatWindowTime">{{ item.create_time.substring(0, 19).replace('T', ' ') }}</p>
                                <div class="ChatWindowIn">
                                    <img src="../assets/images/logo.png" alt="img" class="touxiang"
                                         v-if="item.oper_code === 2003 || item.oper_code === 2001">
                                    <img v-else-if="item.oper_code === 2002" src="../assets/images/default.png" alt="img"
                                         class="touxiang">
                                  <div class="ChatWindowText" v-if="item.type === 'image'"   >
                                      <viewer>
                                          <img :src="item.media_url" style="width: 100px;" alt="">
                                      </viewer></div>
                                  <div class="ChatWindowText" v-else-if="item.type === 'text'"   v-html="item.msg.replace(/\n/g, '<br>')" ></div>
                                  <div class="ChatWindowText" v-else-if="item.type === 'autoquestion'"   >
                                      <p class="el-button">可能想要问的问题：</p>
                                      <p v-for="items in item.msg" class="el-button el-button--default" @click="autoquestion(items.answer.replace(/\n/g, '<br >'),items.id)" >
                                        <span class="" v-html="items.title.replace(/\n/g, '<br >')">
                                      </span>
                                      </p>
                                  </div>
                                    <div class="ChatWindowText" v-else-if="item.type === 'autoanswer'"  >
                                        <p class="autoanswer"  v-html="item.msg.replace(/\n/g, '<br>')">
                                        </p>
                                        <span class="el-button el-button--default " @click="autoanswerres(item.id,'1')">有用</span><span class="el-button el-button--default" @click="autoanswerres(item.id,'2')">没用</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                  <div class="mess-dialogue">
                    <div class="mess-dialogue_content">
                      <div class="InputArea">
                        <div class="InputArea-content">
                          <div class="InputArea-input">
                            <textarea id="inputAreaValue"  class="InputArea-textarea" v-model="Msg" @input ="inputFunc" data-autosize-on="true" placeholder="请输入需要咨询的问题" style="height: 42px;"></textarea>
                          </div>
                          <div id="drawerBtn" class="getDrawer" style="" v-show="drawerbtnshow">
                            <a id="images" href="javascript:"><form id="picture" enctype="multipart/form-data">
                              <div class="layui-box input-but  size"><img src="../assets/images/add.png" alt="">

                                <input
                                    class="fileinput"
                                    type="file"
                                    id="Updateimage"
                                    lay-verify="required"
                                    @change="toBase64()"
                                    accept="image/jpeg, image/png, image/jpg"
                                />
                              </div></form></a>
                          </div>
                          <div class="InputArea-btn" id="InputAreasendbtn" v-show="InputAreasendbtnshow" style="display: none;">
                            <div class="send changeSkinColor" @click="sendMesage">发送</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                        <!--输入框-->
                        <!--<div class="InputBox clear">
                            <div class="InputBoxIcon">

                            </div>
                            <textarea
                                    class="textarea"
                                    placeholder="请输入内容
                按Enter发送 "
                                    @keyup.enter.stop="sendMesage"
                                    v-model="Msg">
                            </textarea>
                          <div class="foot_msg"><div class="footer"><button class="layui-btn layui-btn-normal send-btn" @click="sendMesage">发送
                          </button>
                          </div><div class="msg-toolbar">
                            <a id="images" href="javascript:"><form id="picture" enctype="multipart/form-data">
                              <div class="layui-box input-but  size"><img src="../assets/images/photo.png" alt="">

                                <input
                                    class="fileinput"
                                    type="file"
                                    id="Updateimage"
                                    lay-verify="required"
                                    @change="toBase64()"
                                    accept="image/jpeg, image/png, image/jpg"
                                />
                              </div></form></a>
                          </div>
                         </div>
                        </div> -->

                    </div>
            </div>
        </div>


    </div>
</template>
<script>
    import {formatDate} from '@/util/date'
    export default {
      name: "Msg",
      data() {
        return {
          customerName: "",
          kefuName: "",
          customerImg: "",
          Msg: "",
          ActiveName: "SmartReply",
          AnswerTitle: "",
          AnswerText: "",
          TransferValue: '',
          Tokenval: '',
          TransferOptions: [],
          TransferPopover: false,
          drawerbtnshow: true,
           userinfo:'',
          InputAreasendbtnshow: false,
        };
      },
      computed: {

        customerId() {
          this.Msg = "";
          this.customerName = this.$store.state.currentCustomer.customer_nick_name;
          this.customerImg = this.$store.state.currentCustomer.customer_head_img_url;
          return this.$store.state.currentCustomer.customer_id;
        },
        ContactItem() {
          let megs = this.$store.state.currentRoomMessages;
          return megs;
        },
      },
      methods: {
        checklogin() {
          let accUrl = `${this.axios.wsHost}/api/v1/app/access`;
          if (this.$route.query.userinfo) {
              this.userinfo=  this.$route.query.userinfo;
          }
          if (this.$cookies.get("ctoken")) {
              this.Tokenval = this.$cookies.get("ctoken");
            //更新cookie时间
            this.$cookies.set('ctoken', this.$cookies.get("ctoken"), '7d');
            this.axios.get('/api/v1/app/dialog?nick_name='+this.userinfo).then(resp => {
                if (resp.data.result && resp.data.result.code === 10004) {
                    this.$cookies.set('ctoken', "");
                    this.$message.error('系统错误，请重新打开');
                }else{
                    let roomData = resp.data;
                    this.$store.commit("updateMsgRoomData", roomData);
                    this.$store.commit("updateKfdata", roomData);
                    this.kefuName = this.$store.state.currentKefu.kf_name;
                }
                });
          } 
          
          if (!this.$cookies.get("ctoken") || this.$cookies.get("ctoken") === "") {
            // 没有登录的时候获取登录key

              this.axios.post("/api/v1/app/access", {
              type: "text",
               nick_name:this.userinfo,
            }).then(resp => {
              this.$cookies.set('ctoken', resp.data.result.authorization, '7d');
                this.Tokenval = this.$cookies.get("ctoken");
                  this.initWSocket();
              if (resp.data.result.reply) {
                this.ContactItem.push({
                  create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                  msg: resp.data.result.reply,
                    type: "text",
                  oper_code: 2003,
                });
              }
                  this.axios.get('/api/v1/app/dialog?nick_name='+this.userinfo).then(resp => {
                      let roomData = resp.data;
                      this.$store.commit("updateMsgRoomData", roomData);
                      this.$store.commit("updateKfdata", roomData);
                      this.kefuName = this.$store.state.currentKefu.kf_name;
                  });
            }, err => {
              console.log(err);
            });
          }
        },
          autoquestion(msgs,id,e) {
              this.ContactItem.push({
                  create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                  msg: msgs,
                  id: id,
                  type: "autoanswer",
                  oper_code: 2003,
              });
          },
          autoanswerres(id,status,e) {
              // 没有登录的时候获取登录key

              this.axios.post("/api/v1/app/dialog/autoanswerres", {
                  id:id,
                  status:status,
              }).then(resp => {
                  if (resp.data.result.reply) {
                      this.ContactItem.push({
                          create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                          msg: resp.data.result.reply,
                          type: "text",
                          oper_code: 2003,
                      });
                  }
              }, err => {
                  console.log(err);
              });
          },
        initWSocket() {

            let wsUrl = `${this.axios.wsHost}/api/v1/app/ws?token=${encodeURIComponent(this.Tokenval)}`;
          var openWs = function (that) {
            var ws = new WebSocket(wsUrl);
            ws.onopen = function (evn) {
              that.isOnline = true;
            };
            ws.onmessage = function (evn) {
              that.isOnline = true;
              let responseData = JSON.parse(evn.data);
              // console.log('收到websocket消息', responseData);

              switch (responseData.Type) {
                case 0:
                  // 心跳
                  break;
                case 1:
                    if (responseData.msg_type =="image"){
                  that.ContactItem.push({
                    create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                      media_url: responseData.media_url,
                    type: "image",
                    id: responseData.id,
                    oper_code: 2003,
                  });
                    }else{
                        that.ContactItem.push({
                            create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                            msg: responseData.Body,
                            id: responseData.id,
                            type: "text",
                            oper_code: 2003,
                        });
                    }
                  if (responseData.Kefuname !=""){
                      that.kefuName = responseData.Kefuname;
                  }

                  break;
                  //撤回消息
                case 2:
                    for (let i = 0; i < that.ContactItem.length; i++) {
                        if (that.ContactItem[i].id === responseData.id) {
                            that.ContactItem.splice(i, 1);
                            return
                        }
                    }
                  break;
                default:
                    console.log("未知的Socket指令", responseData);
                  break;
              }
            };

            ws.onclose = function (evn) {
              that.$notify.error({
                title: "连接异常",
                message: "服务器已断开连接，正在尝试重连"
              });
              that.isOnline = false;
            };
            return ws;
          };
          this.$store.commit('initwSocket', openWs(this));

          this.wsHeartBeat = setInterval(() => {
            let ws = this.$store.state.wSocket;
            switch (ws.readyState) {
              case 0:
                break;
              case 1:
                this.$store.state.wSocket.send("+");
                break;
              case 2 | 3:
                this.$store.commit('cleanwSocket');
                this.$store.commit('initwSocket', openWs(this));
                break;
            }
          }, 5000);
        },
        clearStatus() {
          this.Msg = "";
          this.AnswerTitle = "";
          this.AnswerText = "";
        },
        /**
         * 发送消息
         */
        sendMesage() {

          let sendMsg = this.Msg;
          this.clearStatus();
          if (!sendMsg || sendMsg.replace(/\n/g, '').replace(/\s/g, '').length === 0) {
            this.$message.error('不能发送空的内容');
            return
          }
          this.axios.post("/api/v1/app/dialog", {
            type: "text",
            msg: sendMsg,
          }).then(resp => {

            this.InputAreasendbtnshow = false;
            this.drawerbtnshow = true;
            this.ContactItem.push({
              create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
              msg: sendMsg,
              type: "text",
              oper_code: 2002,
            });
            if (resp.data.result.reply) {
              this.ContactItem.push({
                create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                msg: resp.data.result.reply,
                type: "text",
                oper_code: 2003,
              });
            }
          if (resp.data.result.autoquestion) {
              this.ContactItem.push({
                  create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                  msg:  JSON.parse(resp.data.result.autoquestion),
                  type: "autoquestion",
                  oper_code: 2003,
              });
          }


          }, err => {
            this.$message.error('系统错误，请重新打开');
            console.log(err)
          });
        },
        toBase64() {
          var that = this;
          var file = document.querySelector('input[type=file]').files[0];
          console.log("base64", file);
          var filename = file.name;
          var extName = filename.substring(filename.lastIndexOf('.') + 1);
          var reader = new FileReader();
          reader.onloadend = function () {
            //把转换后的数据给id为base64Img的src属性
            console.log(reader.result);
            that.imageUrl = reader.result;
            that.extension_name = extName;
            that.updataImg();
            //这里调用了向后台发请求的代码
          };
          if (file) {
            reader.readAsDataURL(file);
          }
        },
        updataImg() {
          var that = this;
          this.axios.post("/api/v1/app/dialog", {
            type: "image",
            extension_name: that.extension_name,
            media_base64: that.imageUrl,
          }).then(resp => {
            if (resp.data.result.reply) {
              this.ContactItem.push({
                create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                msg: resp.data.result.reply,
                type: "text",
                oper_code: 2003,
              });
            }
            if (resp.data.result.sendmediaurl) {
              this.ContactItem.push({
                create_time: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
                type: "image",
                media_url:  resp.data.result.sendmediaurl,
                oper_code: 2002,
              });
            }

          }, err => {
            this.$message.error('系统错误，请重新打开');
            console.log(err)
          });

        },
        inputFunc() {
          let sendMsgres = this.Msg;
          if (!sendMsgres) {
            this.InputAreasendbtnshow = false;
            this.drawerbtnshow = true;
          } else {
            this.InputAreasendbtnshow = true;
            this.drawerbtnshow = false;
          }
        },
      },
        created() {
          // 初始化WS协议连接
          this.checklogin();
          if (this.$cookies.get("ctoken")){
              this.initWSocket();
          }


        },
        destroyed() {
          clearInterval(this.wsHeartBeat);
        },
        updated: function () {
          var container = document.getElementById("ChatWindow");
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        }
    }
</script>

<style scoped>
    @import "../assets/msg.css";

</style>